var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('colored-box',{staticClass:"subject-titled-box",style:(_vm.setStyle),attrs:{"radius":"normal"}},[_c('div',{staticClass:"subject-titled-box__title font-medium text-large"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }